<template>
  <div class="lxm-cf-project-feedback-detail">
    <!--<lxm-nav :title="'羊宝宝和小兔兔的展览筹款'" :share="true"></lxm-nav>-->

    <div class="page">
      <h2 class="subtitle">反馈详情 {{ state.index }}/{{ state.count }}</h2>

      <transition name="lxm-content-transition" mode="out-in">
        <lxm-row v-if="!loading"
                 :icon-class="'lxm-row__img-icon lxm-row__img-icon--cf-money'"
                 :name="'支付金额'">
          {{ amount }}
        </lxm-row>
      </transition>

      <transition name="lxm-content-transition" mode="out-in">
        <lxm-row v-if="!loading"
                 :icon-class="'lxm-row__img-icon lxm-row__img-icon--cf-status'"
                 :name="'支付状态'">
          <span class="lxm-cf-project-feedback-detail__status">
            <template v-if="state.status.success">
              <span class="lxm-cf-project-feedback-detail__status-success">
                <img class="lxm-cf-project-feedback-detail__status-img lxm-cf-project-feedback-detail__status-img--success" src="../../images/main/cf/success.png" />
                {{ state.statusText }}
              </span>
            </template>
            <template v-else="state.status.success">
              {{ state.statusText }}
            </template>
            <template v-if="state.status.channel">
              &nbsp;
              <img v-if="state.status.channel.indexOf('微信') >= 0" class="lxm-cf-project-feedback-detail__status-img lxm-cf-project-feedback-detail__status-img--weixin" src="../../images/main/cf/weixin.png" />
              {{ state.status.channel }}
            </template>
          </span>
        </lxm-row>
      </transition>

      <transition name="lxm-content-transition" mode="out-in">
        <div v-if="!loading">
          <template v-for="row in rows">
            <lxm-form-row :row="row"></lxm-form-row>
          </template>
        </div>
      </transition>

    </div>
    <!--<lxm-prev-next></lxm-prev-next>-->
  </div>
</template>

<style lang="stylus" scoped>
  @import '../../styles/variables.styl'
  .lxm-cf-project-feedback-detail__status
    line-height: 1
  .lxm-cf-project-feedback-detail__status-success
    color: brand-primary
  .lxm-cf-project-feedback-detail__status-img
    vertical-align: middle
  .lxm-cf-project-feedback-detail__status-img--success
    width: siz(11)
    height: siz(11)
  .lxm-cf-project-feedback-detail__status-img--weixin
    width: siz(16)
    height: siz(14.5)
</style>

<script>
  import LxmNav from '../common/LxmNav.vue'
  import LxmRow from '../common/LxmRow.vue'
  import LxmFormRow from '../common/LxmFormRow.vue'
  import LxmPrevNext from '../common/LxmPrevNext.vue'
  import { numberFormat } from '../../../utils'
  import * as aTypes from '../../../store/action-types'
  export default {
    components: {
      LxmNav,
      LxmRow,
      LxmFormRow,
      LxmPrevNext
    },
    computed: {
      loading () {
        return this.$store.state.loading[aTypes.CF_GET_FEEDBACK_DETAIL]
      },
      state () {
        return this.$store.state.cf.feedbackDetail
      },
      amount () {
        return `¥${numberFormat(this.state.amount, true)}`
      },
      rows () {
        if (this.$store.state.loading[aTypes.CF_GET_FEEDBACK_DETAIL]) {
          return []
        } else {
          return this.state.rows
        }
      }
    },
    mounted () {
      this.getData()
    },
    watch: {
      $route () {
        this.getData()
      }
    },
    methods: {
      getData () {
        this.$store.dispatch(aTypes.CF_GET_FEEDBACK_DETAIL, {
          contactId: this.$route.query.contactId,
          projectId: this.$route.query.projectId,
          donateId: this.$route.query.donateId
        })
        this.$store.dispatch(aTypes.ZHUGE_TRACK, { event: '到达筹款反馈详情页' })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// FeedbackDetail.vue?013dc244